export const isEmailField = (fieldId: string): boolean => !!fieldId.match(/email/i);
